import { Toaster as SonnerToaster } from 'sonner'

import { useTheme } from '@/shared/features/theme/ThemeContext'
import { useToasterPosition } from '@/shared/lib/toastPlacement'

/**
 * App-wide toast surface. Mount once at the root.
 *
 * Defaults:
 *   - bottom-right, stacked; a screen whose action bar owns that corner
 *     (the restaurant order screen) claims it with useClaimToastCorner and
 *     the toasts move clear of it (see toastPlacement.ts)
 *   - 4s auto-dismiss for success/info, 6s for warning/error
 *   - close button on every toast
 *   - rich severity colours (sonner sets role="alert" + aria-live="assertive"
 *     on error/warning, "polite" on success/info, automatically)
 *   - pauses on hover and when the tab is hidden
 *
 * `toast.critical(...)` overrides duration to Infinity for sticky errors.
 */
export function Toaster() {
  const { resolvedTheme } = useTheme()
  const position = useToasterPosition()
  return (
    <SonnerToaster
      position={position}
      richColors
      closeButton
      expand
      theme={resolvedTheme}
      visibleToasts={5}
      toastOptions={{
        // Sit above modal/dialog overlays (z-50). PhoneInput dropdown uses
        // z-[200] so we go above that too for genuinely-critical messages.
        className: 'z-[9999]',
        duration: 5_000,
      }}
    />
  )
}
